import React from 'react'
import { IconCircleDolar, ListItem,  } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../i18n/useTranslation'
import FilterBadge from '../../../common/FilterBadge'

const CREDIT_STATUS = 'withNegativePayment'

const CreditsFilter = (props) => {
  const { translate } = useTranslation()
  const { otherStatusesFilters = [], setOtherStatusesFilters, useInner = false } = props
  const isActive = otherStatusesFilters.includes(CREDIT_STATUS)
  const title = translate('invoices.status.withNegativePayment')

  const toggleCredits = () => {
    setOtherStatusesFilters(isActive ? [] : [CREDIT_STATUS])
  }
  
  if (useInner) {
    return (
      <ListItem
        onClick={toggleCredits}
        className='w-100 hover-no-border py-1'
        hasHover
        Left={
          <span className={`d-flex align-items-center ${isActive ? 'text-primary font-weight-bold' : ''}`}>
            <IconCircleDolar className='mr-2' color='red' />
            {title}
          </span>
        }
        showBottomLine
      />
    )
  }

  return (
    <div className="ant-dropdown-trigger m-0 p-0">
      <FilterBadge
        title={title}
        isActive={isActive}
        showArrow={false}
        onClick={toggleCredits}
        onClearFilters={() => setOtherStatusesFilters([])}
      />

    </div>

  )
}

export default CreditsFilter
